import { Button, Flex, Text } from "@chakra-ui/react";

const NotFound = () => {
  return (
    <Flex
      direction="column"
      flex={1}
      minH="60vh"
      align="center"
      justify="center"
      m="auto"
      textAlign="center"
      px={[6, 12]}
    >
      <Text as="h1" fontSize="48px" fontWeight="semibold">
        Not found
      </Text>

      <Text mt={5} color="text.secondary" fontSize="xl">
        We could not find the page you were looking for.
      </Text>

      <Button as="a" href="/" size="lg" mt={8}>
        Return home
      </Button>
    </Flex>
  );
};

export default NotFound;
